module.exports = __webpack_public_path__ + "static/display-clipped-b0f2b1760d724667ff0a245077948467.png";